// src/pages/SubirCancion.jsx
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, storage } from "../firebaseConfig";
import { doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function SubirCancion() {
  const { userId, cancionId } = useParams();
  const navigate = useNavigate();

  const [fileCover1, setFileCover1] = useState(null);
  const [fileCover2, setFileCover2] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDropCover1 = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type === "audio/mpeg") {
      setFileCover1(file);
      setMensaje("");
    } else {
      setMensaje("El archivo debe ser un MP3.");
    }
  };

  const handleDropCover2 = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type === "audio/mpeg") {
      setFileCover2(file);
      setMensaje("");
    } else {
      setMensaje("El archivo debe ser un MP3.");
    }
  };

  const handleFileChangeCover1 = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "audio/mpeg") {
      setFileCover1(file);
      setMensaje("");
    } else if (file) {
      setMensaje("El archivo debe ser un MP3.");
    }
  };

  const handleFileChangeCover2 = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "audio/mpeg") {
      setFileCover2(file);
      setMensaje("");
    } else if (file) {
      setMensaje("El archivo debe ser un MP3.");
    }
  };

  const handleUpload = async () => {
    try {
      setMensaje("");
      setIsUploading(true);

      if (!fileCover1 && !fileCover2) {
        setMensaje("Selecciona al menos un archivo MP3 para subir.");
        setIsUploading(false);
        return;
      }

      const updates = {};

      // 1) Subir coverUrl (primer MP3)
      if (fileCover1) {
        const storageRef1 = ref(
          storage,
          `subirWeb/${cancionId}_cover1.mp3`
        );
        await uploadBytes(storageRef1, fileCover1);
        const url1 = await getDownloadURL(storageRef1);
        updates.coverUrl = url1;
      }

      // 2) Subir coverUrl02 (segundo MP3)
      if (fileCover2) {
        const storageRef2 = ref(
          storage,
          `subirWeb/${cancionId}_cover2.mp3`
        );
        await uploadBytes(storageRef2, fileCover2);
        const url2 = await getDownloadURL(storageRef2);
        updates.coverUrl02 = url2;
      }

      // 3) Actualizar Firestore
      const cancionRef = doc(db, "usuarios", userId, "canciones", cancionId);
      await updateDoc(cancionRef, updates);

      setMensaje("✅ Archivos subidos y datos actualizados correctamente.");
      setIsUploading(false);

      // Opcional: regresar a detalles de la canción
      // navigate(`/cancion/${userId}/${cancionId}`);
    } catch (error) {
      console.error("Error al subir archivos:", error);
      setMensaje("❌ Ocurrió un error al subir los archivos." + error.mensaje);
      setIsUploading(false);
    }
  };

  return (
    <div
      style={{
        padding: "24px",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <h2>Subir archivos de la canción</h2>
      <p style={{ marginTop: "8px", marginBottom: "16px" }}>
        Usuario: <strong>{userId}</strong> <br />
        Canción: <strong>{cancionId}</strong>
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        {/* Zona 1: coverUrl */}
        <div>
          <h4>Archivo 1 (coverUrl)</h4>
          <div
            onDragOver={handleDragOver}
            onDrop={handleDropCover1}
            style={{
              border: "2px dashed #aaa",
              borderRadius: "10px",
              padding: "24px",
              textAlign: "center",
              cursor: "pointer",
              marginBottom: "8px",
            }}
          >
            <p style={{ marginBottom: "8px" }}>
              Arrastra aquí tu MP3 o haz clic para seleccionar
            </p>
            <input
              type="file"
              accept="audio/mpeg"
              onChange={handleFileChangeCover1}
            />
            {fileCover1 && (
              <p style={{ marginTop: "8px", fontSize: "14px" }}>
                Archivo seleccionado: <strong>{fileCover1.name}</strong>
              </p>
            )}
          </div>
        </div>

        {/* Zona 2: coverUrl02 */}
        <div>
          <h4>Archivo 2 (coverUrl02)</h4>
          <div
            onDragOver={handleDragOver}
            onDrop={handleDropCover2}
            style={{
              border: "2px dashed #aaa",
              borderRadius: "10px",
              padding: "24px",
              textAlign: "center",
              cursor: "pointer",
              marginBottom: "8px",
            }}
          >
            <p style={{ marginBottom: "8px" }}>
              Arrastra aquí tu MP3 o haz clic para seleccionar
            </p>
            <input
              type="file"
              accept="audio/mpeg"
              onChange={handleFileChangeCover2}
            />
            {fileCover2 && (
              <p style={{ marginTop: "8px", fontSize: "14px" }}>
                Archivo seleccionado: <strong>{fileCover2.name}</strong>
              </p>
            )}
          </div>
        </div>
      </div>

      <button
        onClick={handleUpload}
        disabled={isUploading}
        style={{
          padding: "10px 18px",
          borderRadius: "8px",
          border: "none",
          cursor: isUploading ? "default" : "pointer",
          fontWeight: "600",
          opacity: isUploading ? 0.7 : 1,
        }}
      >
        {isUploading ? "Subiendo..." : "Subir MP3 a Storage"}
      </button>

      {mensaje && (
        <p style={{ marginTop: "16px", whiteSpace: "pre-line" }}>{mensaje}</p>
      )}

      <button
        onClick={() => navigate(-1)}
        style={{
          marginTop: "16px",
          marginLeft: "12px",
          padding: "8px 16px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          cursor: "pointer",
          background: "white",
        }}
      >
        Volver
      </button>
    </div>
  );
}

export default SubirCancion;
